import React from 'react';
import { FontAwesomeIcon } from '../../libs/fonts';

const OrangeHoverCard = ({ icon, title, text, number }) => (
  <div className='col-lg-4 col-md-6 mb-20'>
    <div className='services-item'>
      <div className='services-icon'>
        {/* FIXME make the icon not be covered when the card is hovered! */}
        <FontAwesomeIcon size='4x' icon={icon} className='orange-icon' />
      </div>
      <div className='services-content'>
        <div className='services-text'>
          <h3 className='title'>{title}</h3>
        </div>
        <p className='services-txt'>{text}</p>
        <div className='serial-number'>
          {number < 10 && '0'}{number}
        </div>
      </div>
    </div>
  </div>
);

export default OrangeHoverCard;
